module.exports = __webpack_public_path__ + "img/floor_EG-en.fc941113.svg";